/* eslint-disable import/no-cycle */
import React, { useState, useRef, useEffect } from 'react';
import { getRangeAddress, SpreadsheetComponent, SheetsDirective, SheetDirective, RangesDirective, RangeDirective, ColumnsDirective, ColumnDirective, RowsDirective, RowDirective, CellsDirective, CellDirective } from '@syncfusion/ej2-react-spreadsheet';
import { Header } from '.';

const Spreadsheet = ({ dt }) => {
  const spreadsheetRef = useRef(null);
  // 1. Define your dropdown data as a state variable
  const [options, setOptions] = useState([]);

  let usr = localStorage.getItem('user');
  let selectedOrg = localStorage.getItem('organization');
  if (!usr || !selectedOrg) {
    // Redirect
    return <p>Please login... </p>;
  }
  usr = JSON.parse(usr);
  selectedOrg = JSON.parse(selectedOrg);
  const { REACT_APP_API_ENDPOINT } = process.env;
  const [jobsdata, setJobsData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [schedules, setSchedules] = useState([]);
  const [associates, setAssociates] = useState([]);

  const [now, setNow] = useState(new Date());

  const cellSave = (args) => {
    const spreadsheet = spreadsheetRef.current;

    // Perform actions when cell data changes
    // console.log('Cell changed:', args);
    // Example: Update the same cell or another cell to force a re-render
    // spreadsheet.updateCell({ value: args.value }, args.address);
    if (args.address === 'Schedule!A6') {
      spreadsheet.updateCell({ value: args.value }, args.address);
      setNow(new Date(args.value));
    }
  };
  const fileMenuItemSelect = (args) => {
    // Check if the clicked item is your custom item
    if (args.item.text === 'EMAIL') {
      console.log('EMAIL File Menu item clicked!');
      // Add your custom logic here
    }
    if (args.item.text === 'SMS') {
      console.log('SMS File Menu item clicked!');
      // Add your custom logic here
    }
  };

  const onCreated = () => {
    const spreadsheet = spreadsheetRef.current;
    spreadsheet.updateRange({
      dataSource: schedules,
      startCell: 'A7',
      width: 200,
    });
    if (spreadsheet.activeSheetIndex === 0) {
      spreadsheet.setColWidth(200, 0);
      spreadsheet.setColWidth(200, 1);
      spreadsheet.setColWidth(200, 2);
      spreadsheet.setColWidth(200, 3);
      spreadsheet.setColWidth(200, 4);
      spreadsheet.setColWidth(200, 5);
      spreadsheet.setColWidth(200, 6);
      spreadsheet.setColWidth(200, 7);
      spreadsheet.setColWidth(200, 8);
      spreadsheet.setColWidth(200, 9);
      spreadsheet.setColWidth(200, 10);
      spreadsheet.setColWidth(200, 11);
      spreadsheet.setColWidth(200, 12);
      spreadsheet.setColWidth(200, 13);
      spreadsheet.setColWidth(200, 14);
      spreadsheet.setColWidth(200, 15);
      spreadsheet.cellFormat({ textAlign: 'center' }, 'A7:Z200');
      spreadsheet.wrap('A7:Z200');
      spreadsheet.hideRow(6, 6, true);
      spreadsheet.cellFormat({ fontWeight: 'bold' }, 'A7:Z7');
      spreadsheet.cellFormat({ fontWeight: 'bold', color: 'red' }, 'A14:Z14');
    }

    /*
    spreadsheet.updateRange({
      dataSource: associates,
      sheetIndex: 1,
      startCell: 'A1',
    });
    spreadsheet.updateRange({
      dataSource: jobsdata,
      sheetIndex: 2,
      startCell: 'A1',
    });
    */
    if (spreadsheetRef.current && spreadsheet.activeSheetIndex === 0) {
      // 2. Format options as a comma-separated string for the 'List' type
      const listSource = options.join(',');
      // 3. Assign validation to the specific column range (e.g., B2:B10)
      spreadsheetRef.current.addDataValidation({
        type: 'List',
        value1: listSource,
        ignoreBlank: true,
        inCellDropDown: true,
      }, 'C6:C20'); // Target Range
    }
    const emailItem = [{ text: 'EMAIL', id: 'email', iconCss: 'e-icons e-emoji' }];
    const smsItem = [{ text: 'SMS', id: 'sms', iconCss: 'e-icons e-next-comment' }];
    // Add the item to the file menu (placed after 'Print' in this example)
    spreadsheet.addFileMenuItems(emailItem, 'Print', false);
    spreadsheet.addFileMenuItems(smsItem, 'EMAIL', false);
  };

  const beforeOpen = () => {};
  const openComplete = () => {
    const spreadsheet = spreadsheetRef.current;
    console.log('Spreadsheet openComplete...', spreadsheet);

    if (spreadsheet) {
      const { sheets } = spreadsheet;
      for (let index = 0; index < sheets.length; index += 1) {
        const { name } = spreadsheet.sheets[index];
        // const protectSetting = { selectCells: true, formatCells: false };
        // To protect the sheet using sheet name
        // spreadsheet.protectSheet(name, protectSetting);
        const address = getRangeAddress([0, 0, sheets[index].usedRange.rowIndex, sheets[index].usedRange.colIndex]);
        console.log('Spreadsheet Locking...', address, name);

        // To lock the used range cells
        // spreadsheet.lockCells(`${name}!${address}`, true);
      }
    }
  };
  // const [mgrData, setMgrData] = useState([]);
  useEffect(() => {
    // limit associates to the overall selection
    if (usr && selectedOrg && selectedOrg.id && selectedOrg.id.length > 0) {
      usr.organizationid = dt._id;
      usr.organization = dt.title;
    }
    // fetch data
    const dataFetch = async () => {
      try {
        const query = Object.entries(usr)
          .map(([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(v)}`)
          .join('&');
        const url = `${REACT_APP_API_ENDPOINT}/jobs?${query}`;
        const mydata = await (
          await fetch(url, {
            method: 'GET',
            headers: {
              'Content-Type': 'application/json',
              Authorization: `JWTToken ${usr.token}`,
            },
          })
        ).json();
        const mylocs = [];
        if (mydata.locations) {
          mydata.locations.forEach((kml) => {
            if (kml.document.name.includes('~') && kml.document.folder && kml.document.folder.name && !kml.document.folder.name.includes('~')) {
              mylocs.push({ value: kml._id, text: kml.document.folder.name });
            } else {
              mylocs.push({ value: kml._id, text: kml.document.name });
            }
          });
        }
        const mymgrs = [];
        if (mydata.managers) {
          mydata.managers.forEach((mgr) => {
            // mymgrs.push({ value: mgr._id, text: `${mgr.first} ${mgr.last}` });
            mymgrs.push(`${mgr.first} ${mgr.last}`);
          });
        }
        const mySchedule = [];
        const myScheduleTitle = [];
        const myScheduleComments = [];
        const myScheduleStart = [];
        const myScheduleEnd = [];
        const myScheduleStartTime = [];
        const myScheduleEndTime = [];
        const myScheduleManager = [];
        const myScheduleDays = [];
        const myScheduleNights = [];
        const myScheduleDaysA = [];
        const myScheduleNightsA = [];
        const myScheduleBlank = [];
        mydata.jobs.forEach((element, index) => {
          if (!element.title) {
            console.log('no element title');
            // return;
          }
          if (!element.date || !element.enddate) {
            console.log('no element date');
            // return;
          }
          const sdt = new Date(element.date);
          const edt = new Date(element.enddate);
          if (sdt === 'Invalid Date' || edt === 'Invalid Date') {
            console.log('invalid data');
            // return;
          }
          if (now < sdt) {
            console.log('now < sdt', now, mydata.jobs[index].title);
            // return;
          }
          if (now > edt) {
            console.log('now > edt', now, mydata.jobs[index].title);
            // return;
          }

          if (element.location && element.location.name) {
            mydata.jobs[index].locationName = element.location.name;
          } else {
            mydata.jobs[index].locationName = 'unassigned';
          }
          // const { title } = element;

          let manager = 'Unassigned';
          if (element.manager) {
            manager = element.manager;
          }
          if (!mymgrs.includes(manager)) {
            mymgrs.push(manager);
          }
          /*
          let comments = '';
          if (element.description) {
            comments = element.description;
          }
          */
          // const schedule = { title, comments, manager, start: element.date, time: element.time, end: element.enddate, endtime: element.endtime };
          // mySchedule.push(schedule);
          myScheduleTitle.push(element.title);
          myScheduleComments.push(`Comments: ${element.description}`);
          myScheduleStart.push(element.date);
          myScheduleStartTime.push(`Start Time: ${element.time}`);
          myScheduleEnd.push(element.enddate);
          myScheduleEndTime.push(element.endtime);
          myScheduleManager.push(`Field Mgr in Charge: ${element.manager}`);

          myScheduleDaysA.push(associates[0].name);
          myScheduleDays.push('DAYS');
          myScheduleBlank.push('');

          if (element.time === element.endtime) {
            myScheduleNights.push('NIGHTS');
            myScheduleNightsA.push(associates[1].name);
          } else {
            myScheduleNights.push('');
            myScheduleNightsA.push('');
          }
        });
        // setMgrData(mymgrs);
        setOptions(mymgrs);
        mySchedule.push(myScheduleManager);
        mySchedule.push(myScheduleTitle);
        mySchedule.push(myScheduleComments);
        // mySchedule.push(myScheduleStart);
        mySchedule.push(myScheduleBlank);
        mySchedule.push(myScheduleStartTime);
        // mySchedule.push(myScheduleEnd);
        mySchedule.push(myScheduleBlank);
        // mySchedule.push(myScheduleEndTime);
        mySchedule.push(myScheduleDays);
        mySchedule.push(myScheduleDaysA);
        mySchedule.push(myScheduleBlank);
        mySchedule.push(myScheduleNights);
        mySchedule.push(myScheduleNightsA);
        setSchedules(mySchedule);
        setJobsData(mydata.jobs);
        setLoading(false);
        if (spreadsheetRef && spreadsheetRef.current) {
          const spreadsheet = spreadsheetRef.current;
          // spreadsheet.refresh(); // "true" creates a new workbook
          spreadsheet.updateRange({
            dataSource: mySchedule,
            startCell: 'A7',
            width: 200,
          });
          if (spreadsheet.activeSheetIndex === 0) {
            spreadsheet.setColWidth(200, 0);
            spreadsheet.setColWidth(200, 1);
            spreadsheet.setColWidth(200, 2);
          }
        }
      } catch (err) {
        setJobsData([]);
        setLoading(false);
      }
    };
    // set state when the data received
    if (associates.length > 0) {
      dataFetch();
    }
  }, [now, associates]); // mapDisplay
  // const [mgrData, setMgrData] = useState([]);
  useEffect(() => {
    // limit associates to the overall selection
    if (selectedOrg && selectedOrg.id && selectedOrg.id.length > 0) {
      usr.organizationid = dt._id;
      usr.organization = dt.title;
    }
    // fetch data
    const associateFetch = async () => {
      try {
        const query = Object.entries(usr)
          .map(([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(v)}`)
          .join('&');
        const url = `${REACT_APP_API_ENDPOINT}/associates?${query}`;
        const mydata = await (
          await fetch(url, {
            method: 'GET',
            headers: {
              'Content-Type': 'application/json',
              Authorization: `JWTToken ${usr.token}`,
            },
          })
        ).json();
        const myAssociates = [];
        mydata.associates.forEach((a) => {
          const e = `=HYPERLINK("mailto:"${a.email}, Email ${a.email})`;
          const ma = { name: a.name, mobile: a.mobile, email: e, dl: 'Y', cdl: 'N', status: 'Available', manager: 'N', jobtask: a.jobtask };
          myAssociates.push(ma);
        });
        setAssociates(myAssociates);
      } catch (err) {
        setAssociates([]);
      }
    };
    // set state when the data received
    associateFetch();
  }, []); // mapDisplay
  if (loading) {
    return <p>loading...</p>;
  }
  return (
    <div className="m-2 md:m-1 mt-2 p-1 md:p-1 bg-white rounded-3xl zackat-divalh">
      <Header category="Administration" title="Spreadsheet" />
      <SpreadsheetComponent
        ref={spreadsheetRef}
        created={onCreated}
        allowOpen
        fileMenuItemSelect={fileMenuItemSelect}
        cellSave={cellSave}
        openComplete={openComplete}
        height={800}
        allowSave
        allowWrap
        openUrl="https://document.syncfusion.com/web-services/spreadsheet-editor/api/spreadsheet/open"
        saveUrl="https://document.syncfusion.com/web-services/spreadsheet-editor/api/spreadsheet/save"
        beforeOpen={beforeOpen}

      >
        <SheetsDirective>
          <SheetDirective name="Schedule" showHeaders={false}>
            <RowsDirective index={0}>
              {/* Define Row 1 as a Header */}
              <RowDirective>
                <CellsDirective>
                  <CellDirective
                    value={`${dt.title}\n\n${now}\n\nWork Schedule`}
                    index={0}
                    colSpan={26}
                    rowSpan={5}
                    style={{ textAlign: 'Center', verticalAlign: 'Middle' }}
                  />
                </CellsDirective>
              </RowDirective>
            </RowsDirective>
          </SheetDirective>
          {/* Sheet 1: Mapped from array */}
          <SheetDirective name="Associates">
            <RangesDirective>
              <RangeDirective dataSource={associates} />
            </RangesDirective>
            <ColumnsDirective>
              <ColumnDirective width={150} />
              <ColumnDirective width={100} />
              <ColumnDirective width={200} />
              <ColumnDirective width={40} />
              <ColumnDirective width={40} />
              <ColumnDirective width={40} />
              <ColumnDirective width={40} />
              <ColumnDirective width={200} />
            </ColumnsDirective>
          </SheetDirective>
          {/* Sheet 1: Mapped from array */}
          <SheetDirective name="Jobs Data">
            <RangesDirective>
              <RangeDirective dataSource={jobsdata} />
            </RangesDirective>
            <ColumnsDirective>
              <ColumnDirective width={150} />
              <ColumnDirective width={100} />
              <ColumnDirective width={100} />
            </ColumnsDirective>
          </SheetDirective>
        </SheetsDirective>
      </SpreadsheetComponent>
      <div className="e-adaptive-demo e-bigger" />
    </div>
  );
};
export default Spreadsheet;
